var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 73,
    viewBox: "0 0 77 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75,
    height: 71,
    stroke: "#58CDFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 30H54.1111C55.1543 30 56 30.8315 56 31.8571V54.1429C56 55.1686 55.1543 56 54.1111 56H23.8889C22.8457 56 22 55.1686 22 54.1429V31.8571C22 30.8315 22.8457 30 23.8889 30H27.6667V28.1429C27.6667 21.9888 32.7408 17 39 17C45.2592 17 50.3333 21.9888 50.3333 28.1429V30ZM25.7778 33.7143V52.2857H52.2222V33.7143H25.7778ZM37.1111 41.1429H40.8889V44.8571H37.1111V41.1429ZM29.5556 41.1429H33.3333V44.8571H29.5556V41.1429ZM44.6667 41.1429H48.4444V44.8571H44.6667V41.1429ZM46.5556 30V28.1429C46.5556 24.0402 43.1727 20.7143 39 20.7143C34.8272 20.7143 31.4444 24.0402 31.4444 28.1429V30H46.5556Z",
    fill: "#58CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.794008f9cc0467987e745c7dfb36c0a7.svg";
export { ForwardRef as ReactComponent };